import React from 'react';

export const MarkerFlat = () => (
  <>
    <g opacity="0.25" strokeWidth="0.02777778" transform="scale(36)">
      <path
        strokeWidth="0.02777778"
        fill="#1875f0"
        d="M 15,30 C 23.284,30 30,23.284 30,15 30,6.716 23.284,0 15,0 6.716,0 0,6.716 0,15 0,23.284 6.716,30 15,30 Z"
      />
    </g>
    <path
      fill="#1875f0"
      strokeWidth="1.00000012"
      d="M 540,936 C 758.7,936 936,758.7 936,540 936,321.3 758.7,144 540,144 321.3,144 144,321.3 144,540 c 0,218.7 177.3,396 396,396 z"
    />
    <path
      d="m 540,720 a 180,180 0 1 0 0,-360 180,180 0 0 0 0,360 z"
      fill="#ffffff"
      strokeWidth="1.00000012"
    />
  </>
);
